import React from "react";
import Carousel from "./carousel/carousel";
import Mantra_11_A1 from "./Mantra11/Mantra11_A1";
import Mantra_18 from "./Mantra18/Mantra18";
import Mantra22 from "./Mantra22/Mantra22";
import Mantra24 from "./Mantra24/Mantra24";
import Mantra26 from "./Mantra26/Mantra26";
import Mantra30 from "./Mantra30/Mantra30";
import Mantra33_1 from "./Mantra33/mantra33_1";
import Mantra_5_A1 from "./Mantra5/Mantra_5_A1";
import Mantra6_1 from "./Mantra6/mantra6_1";
import Mantra_3_A1 from "./Mantra_3_A1";
import Mantra31 from "./Mantra31/Mantra31";
import Upload from "./Upload";
import Mantra32 from "./Mantra32/Mantra32";
import Mantra20 from "./Mantra20/Mantra20";
import { imageStore, shareSuccessStore } from "../config/store";
import { NavLink } from "react-router-dom";
import { onClickNavLinkMantra } from "../utils/helper";
import Mantra22b from "./Mantra22b/Mantra22b";
import Mantra_21_A2 from "./Mantra21_A2/Mantra_21_A2";
import Mantra_FillEmailDownload from "./commonmantra/Mantra_FillEmailDownload";

export default class InnerPagesLoop extends React.Component {
  constructor() {
    super();
    this.state = {
      blocks: null,
      direction: null,
      showThankyouPopup: false,
    };
  }

  componentDidMount() {
    this.setState({ blocks: this.props.data });
    shareSuccessStore.subscribe(() => {
      let item = shareSuccessStore.getState().data;
      if (item.shared) {
        this.setState({ showThankyouPopup: true });
        imageStore.dispatch({
          type: "SET_IMG",
          data: { open: false },
        });
      } else {
        this.setState({ showThankyouPopup: false });
      }
    });
  }

  handleThankyouOkay = () => {
    let open = true;
    if (navigator && navigator.canShare) {
      open = false;
    }
    imageStore.dispatch({
      type: "SET_IMG",
      data: { open },
    });
    this.setState({ showThankyouPopup: false });
  };

  render() {
    var module_name = this.props.params.name;
    const { blocks } = this.state;


    // console.log(blocks, 'blocksgf')

    return (
      <>
        {blocks &&
          Object.keys(blocks).length > 0 &&
          Object.keys(blocks).map((key, index) => {
            let component = null;

            // var res = module_name.length == 2 ? module_name.substring(0, 2) : module_name.substring(0, 3);

            if (key == module_name) {
              let keys = Object.keys(blocks);
              let newkeys = [];
              keys.map((val) => {
                if (val.indexOf("extra") == -1) {
                  newkeys.push(val);
                }
              });
              let index = newkeys.indexOf(module_name);
              let next = newkeys.length - 1 > index ? newkeys[index + 1] : null;
              let prev = index > 0 ? newkeys[index - 1] : null;

              // let type = blocks ? blocks[res] && blocks[res]['activity'][module_name].type : ''
              let type = blocks[key].type;
              let module = blocks[key].module ? blocks[key].module : null;
              // let pageData = blocks ? blocks[res] && blocks[res]['activity'][module_name] : ''
              let pageData = blocks[key];
              if (type == "upload" && pageData) {
                component = (
                  <Upload
                    module_name={module_name}
                    type={type}
                    pageData={pageData}
                  />
                );
              } else if (type == "laugh_card" && pageData) {
                component = (
                  <Mantra_3_A1
                    module_name={module_name}
                    type={type}
                    pageData={pageData}
                  />
                );
              } else if (type == "template_download") {
                component = (
                  <Mantra6_1
                    module_name={module_name}
                    type={type}
                    pageData={pageData}
                  />
                );
              } else if (type == "like-two") {
                component = (
                  <Mantra_11_A1
                    module_name={module_name}
                    type={type}
                    pageData={pageData}
                  />
                );
              } else if (type == "personality") {
                component = (
                  <Mantra_5_A1
                    module_name={module_name}
                    type={type}
                    pageData={pageData}
                  />
                );
              } else if (type == "certificate") {
                component = (
                  <Mantra_18
                    module_name={module_name}
                    type={type}
                    pageData={pageData}
                  />
                );
              } else if (module === "mantra22b") {
                component = (
                  <Mantra22b module_name={module_name}
                    type={type}
                    pageData={pageData} />
                );
              } else if (module == "mantra33") {
                component = (
                  <Mantra33_1
                    module_name={module_name}
                    type={type}
                    pageData={pageData}
                  />
                );
              } else if (type == "download_or_fill") {
                component = <Mantra_21_A2
                  module_name={module_name}
                  type={type}
                  pageData={pageData}
                />
              } else if (type == "fill_email_download") {
                component = <Mantra_FillEmailDownload
                  module_name={module_name}
                  type={type}
                  pageData={pageData}
                />
              }

              return (
                <div key={index}>
                  <Carousel data={pageData} next={next} prev={prev} />

                  {this.state.showThankyouPopup ? (
                    <div className="container">
                      <div className="shared_post">
                        <img
                          src="/assets/img/thank.png"
                          className="img-fluid d-block mx-auto"
                          alt=""
                        />
                        <h5>Your post has been shared!</h5>
                      </div>
                      <div className="preview_btn">
                        <a href="#" onClick={() => this.handleThankyouOkay()}>
                          Okay
                        </a>
                      </div>
                      <div className="home_btn">
                        <NavLink to={"/"} onClick={() => onClickNavLinkMantra("", { name: "home" })}>
                          Go to Mantra's Home &#10230;
                        </NavLink>
                      </div>
                    </div>
                  ) : (
                      component
                    )}

                </div>
              );
            }
          })}
      </>
    );
  }
}
